<div class="ui-g">
    <div class="ui-g-12">  
        <p-panel header="{{ 'data_export' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
            <p (click)="downloadUsersExcel()" class="download-link" style="margin-bottom: 20px;">{{ 'generate_excel_users' | translate }}</p>
            <app-loader *ngIf="showLoaderUsers"></app-loader>
        </p-panel>
        <p-panel header="{{ 'invoices' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
            <p style="margin-bottom: 8px;">Pobieranie wszystkich faktur z podanego zakresu dat.</p>
            <div class="calendar-box">
                <p-calendar dateFormat="yy-mm-dd" [(ngModel)]="dateFrom"  placeholder="{{ 'date_from' | translate}}"></p-calendar>
            </div>
            <div class="calendar-box">
                <p-calendar dateFormat="yy-mm-dd" [(ngModel)]="dateTo" placeholder="{{ 'date_to' | translate}}"></p-calendar>
            </div>
            <button (click)="downloadInvoices()" pButton type="button" label="{{ 'download' | translate }}" class="p-button-text"></button>
            <app-loader *ngIf="showLoaderInvoices"></app-loader>
        </p-panel>
    </div>
</div>